import axios from 'axios';
import { Message } from 'element-ui'

export const request = function (config) {
    // 参数配置
    var tempConfig ={
        url: '',
        method: 'get',
        params: {},
        baseURL: 'https://crm.mansul.com/api/',
        timeout: 3000
    }
    Object.assign(tempConfig, config);
    return new Promise((resolve, reject) => {
        axios.request(tempConfig).then(res => {
            if (res.data.code == 1) {
                resolve(res.data)
            } else {
                Message({
                    message: '请求失败，请刷新',
                    type: 'error',
                    duration: 5 * 1000
                })
            }
        }).catch(err => {
            Message({
                message: '请求失败，请刷新',
                type: 'error',
                duration: 5 * 1000
            })
            reject(err)
        })
    })
}

